import script from "./allEpgs.vue?vue&type=script&lang=ts&setup=true"
export * from "./allEpgs.vue?vue&type=script&lang=ts&setup=true"

import "./allEpgs.vue?vue&type=style&index=0&id=6d18aab1&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d18aab1"]])

export default __exports__